import "intersection-observer";
import "mapbox-gl/dist/mapbox-gl.css";
import DefaultLP from './LoadingPlaceholders/DefaultLP';
import { createApp } from './app';
import isMapboxBlockedCrawler from './utils/isMapboxBlockedCrawler';

const { app, i18n, store, router } = createApp(undefined, window.__INITIAL_STATE__?.previewProfile);

if (window.__INITIAL_STATE__) {
  if (window.__INITIAL_STATE__.i18n) {
    i18n.mergeLocaleMessage(i18n.locale, {
      ...window.__INITIAL_STATE__.i18n[i18n.locale]
    });
    delete window.__INITIAL_STATE__.i18n;
  } 
  store.replaceState(window.__INITIAL_STATE__);
  // Initial browser navigation already includes the URL hash. Replacing it here
  // cancels Vue Router 3.6's pending navigation before onReady can mount the app.
  delete window.__INITIAL_STATE__;
}

store.dispatch('ui/UPDATE_DISABLE_MAPBOX', {
  disableMapbox: isMapboxBlockedCrawler(navigator.userAgent)
});

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

window.passiveIfSupported = false;

try {
  window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function() { window.passiveIfSupported = { passive: true }; } }));
} catch(err) {}

const getPathLocale = (p) => {
  p = p.split('/');
  return p[0] ? p[0] : p[1];
} 

router.onReady(() => {
  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to)
    const langChange = getPathLocale(to.path) != getPathLocale(from.path);
    const session = Date.now() + '-' + Math.ceil(Math.random() * 100);
    let loadingPlaceholder = matched.reduce((lp, c) => {      
      return c.loadingPlaceholder 
        ? c.loadingPlaceholder
        : lp 
    }, DefaultLP);
    store.dispatch('ui/SET_PAGE_LOADING_PLACEHOLDER', {
      component: langChange 
        ? loadingPlaceholder
        : null
    });

    store.dispatch('ui/START_ROUTING');
    console.log('[DEBUG] Start routing...', {from: from.path, to: to.path});
    let uitRequests = [];
    const requests = matched.reduce((all, c) => {
      uitRequests.push(store.dispatch('uit/FETCH_UIT', { component: c, i18n: i18n }));

      if (c.asyncData) {
        all.push(c.asyncData({ i18n, store, route: to, next }));
      }

      return all;
    }, []).map(p => p.then(() => {
      store.dispatch('progress/DONE', { session });
    }))

    store.dispatch('progress/START', { total: requests.length + 1, session });

    uitRequests = Promise.all(uitRequests).then(() => {
      console.log('[DEBUG]', 'SET TO DEFAULT', to);
      i18n.fallbackLocale = 'default';
      store.dispatch('progress/DONE', { session });
    })

    // window && window.scrollTo(0, 0);
    const start = new Date();
    Promise.all(requests.concat([uitRequests])).then(() => {
      const cost = (new Date() - start);
      console.log('[DEBUG] routing', cost);
      if (cost < 100 || cost > 500) {
        store.dispatch('ui/FINISH_ROUTING');
        next();
        return ;
      }
      setTimeout(() => {
        store.dispatch('ui/FINISH_ROUTING');
        next();
      }, 500 - cost);      
    }).catch(error => {
      const path = to.path.split('/').slice(2).join('/');
      const status = error && error.response && error.response.status;
      store.dispatch('ui/FINISH_ROUTING');
      store.dispatch('progress/DONE', { session });
      // Handle network errors and UIT rejection without awaiting the rejected batch again.
      if (to.name && to.name.startsWith('SomethingWrong')) {
        next();
        return;
      }
      next({
        name: `${status >= 400 && status < 500 ? 'NotMatchFound' : 'SomethingWrongKeepURL'}_${i18n.locale}`,
        params: { '0': path },
        query: to.query
      });
    })
  })
  try {
    app.$mount("#app");
  } catch (error) {
    console.error(error);
  }
});
